var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.142,
    height: 19.142,
    viewBox: "0 0 19.142 19.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.996;}.b,.c{fill:none;}.c{stroke:#454f63;stroke-linecap:round;stroke-width:2px;}.d,.e{stroke:none;}.e{fill:#454f63;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7.728,0A7.728,7.728,0,1,1,0,7.728,7.728,7.728,0,0,1,7.728,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 7.727783203125 2.000002861022949 C 4.569473266601562 2.000002861022949 2.000002861022949 4.569473266601562 2.000002861022949 7.727783203125 C 2.000002861022949 10.88609313964844 4.569473266601562 13.45556354522705 7.727783203125 13.45556354522705 C 10.88609313964844 13.45556354522705 13.45556354522705 10.88609313964844 13.45556354522705 7.727783203125 C 13.45556354522705 4.569473266601562 10.88609313964844 2.000002861022949 7.727783203125 2.000002861022949 M 7.727783203125 2.86102294921875e-06 C 11.99571323394775 2.86102294921875e-06 15.45556354522705 3.459843635559082 15.45556354522705 7.727783203125 C 15.45556354522705 11.99571323394775 11.99571323394775 15.45556354522705 7.727783203125 15.45556354522705 C 3.459843635559082 15.45556354522705 2.86102294921875e-06 11.99571323394775 2.86102294921875e-06 7.727783203125 C 2.86102294921875e-06 3.459843635559082 3.459843635559082 2.86102294921875e-06 7.727783203125 2.86102294921875e-06 Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 5,
    y2: 5,
    transform: "translate(12.728 12.728)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e0f1bff1abe50b093b80412fd2783a4b.svg";
export { ForwardRef as ReactComponent };